import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const PRIORITIZATION_TECHNIQUES = {
    EISENHOWER: {
        name: "Eisenhower Matrix",
        description: "Organize tasks by urgency and importance in 4 quadrants: Do (urgent+important), Decide (important only), Delegate (urgent only), Delete (neither)"
    },
    MOSCOW: {
        name: "MoSCoW Method", 
        description: "Prioritize requirements as Must Have (critical), Should Have (important), Could Have (nice-to-have), Won't Have (excluded)"
    },
    KANBAN: {
        name: "Kanban Board",
        description: "Visual workflow with columns showing task progress: To Do → In Progress → Review → Done. Move tasks through stages as you work"
    },
    GTD: {
        name: "Getting Things Done",
        description: "Capture everything, clarify actions needed, organize by context, review regularly, and engage with confidence"
    }
};

const TIME_MANAGEMENT_TECHNIQUES = {
    POMODORO: {
        name: "Pomodoro Technique",
        description: "Work in focused 25-minute intervals followed by 5-minute breaks. Take longer breaks after 4 cycles"
    },
    TIME_BLOCKING: {
        name: "Time Blocking",
        description: "Schedule specific time blocks for different activities. Assign tasks to dedicated time slots in your calendar"
    },
    CALENDAR: {
        name: "Calendar Scheduling",
        description: "Use calendar events and reminders to structure your day and ensure important tasks get dedicated time"
    }
};

const TechniqueSettingsModal = ({ show, handleClose, profileTechniques, onUpdateTechniques }) => {
    const [primaryPrioritization, setPrimaryPrioritization] = useState('');
    const [primaryTimeManagement, setPrimaryTimeManagement] = useState('');

    // Update state when modal opens or profileTechniques changes
    React.useEffect(() => {
        if (show && profileTechniques) {
            setPrimaryPrioritization(profileTechniques.primaryPrioritization || '');
            setPrimaryTimeManagement(profileTechniques.primaryTimeManagement || '');
        }
    }, [show, profileTechniques]);

    const handleSubmit = () => {
        onUpdateTechniques({
            primary_prioritization: primaryPrioritization,
            primary_time_management: primaryTimeManagement
        });
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Technique Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Prioritization Technique</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={primaryPrioritization}
                                    onChange={(e) => setPrimaryPrioritization(e.target.value)}
                                >
                                    <option value="">Select method...</option>
                                    {Object.entries(PRIORITIZATION_TECHNIQUES).map(([key, technique]) => (
                                        <option key={key} value={key}>{technique.name}</option>
                                    ))}
                                </Form.Control>
                                {primaryPrioritization && PRIORITIZATION_TECHNIQUES[primaryPrioritization] && (
                                    <Form.Text className="text-muted">
                                        {PRIORITIZATION_TECHNIQUES[primaryPrioritization].description}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Time Management Technique</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={primaryTimeManagement}
                                    onChange={(e) => setPrimaryTimeManagement(e.target.value)}
                                >
                                    <option value="">Select method...</option>
                                    {Object.entries(TIME_MANAGEMENT_TECHNIQUES).map(([key, technique]) => (
                                        <option key={key} value={key}>{technique.name}</option>
                                    ))}
                                </Form.Control>
                                {primaryTimeManagement && TIME_MANAGEMENT_TECHNIQUES[primaryTimeManagement] && (
                                    <Form.Text className="text-muted">
                                        {TIME_MANAGEMENT_TECHNIQUES[primaryTimeManagement].description}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TechniqueSettingsModal;
